import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import QRCode from "qrcode";
import Drawer from "@mui/material/Drawer";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { alertMessage } from "../../actions/auth";
import { Bar } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { Chart } from "chart.js/auto";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Fab } from "@mui/material";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PublishIcon from "@mui/icons-material/Publish";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import { API_URL } from "../../actions/auth";
import { themeStyle } from "../../components/Components";
import AddIcon from "@mui/icons-material/Add";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material";
import { CloudUpload, Description, Close } from "@mui/icons-material";

const Dropzone = styled("div")(({ theme }) => ({
  border: `2px dashed ` + themeStyle.primaryColor,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(6),
  textAlign: "center",
  cursor: "pointer",
}));

const FileUploadCard = () => {
  return (
    <Box sx={{ maxWidth: 400, mx: "auto", marginBottom: "50px" }} elevation={1}>
      <Dropzone>
        <CloudUpload
          fontSize="large"
          sx={{ color: themeStyle.primaryColor, mb: 1, fontSize: "50px" }}
        />
        <Typography variant="body1">Click here to upload your file</Typography>
        <Typography variant="caption" color="text.secondary">
          with .xlsx file extension (Max 25MB)
        </Typography>
      </Dropzone>
    </Box>
  );
};

function Inventory() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [imgError, setImgError] = useState(false);
  const [ogInventory, setOGInventory] = useState([]);
  const [random, setRandom] = useState(0);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [search, setSearch] = useState("");
  const [product, setProduct] = useState({});
  const [open, setOpen] = useState(false);
  const [isUploading, setIsUploading] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [inventoryList, setInventoryList] = useState([]);
  const [selectedPage, setSelectedPage] = useState("STUDENTS");
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [select, setSelect] = useState("Electronics");
  const [inventoryName, setInventoryName] = useState("");
  const [minimum, setMinimum] = useState("");
  const [inventoryDescription, setInventoryDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isPerishable, setIsPerishable] = useState(false);
  const [stock, setStock] = useState("");
  const [newCategory, setNewCategory] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [categories, setCategories] = useState([]);
  const [invoice, setInvoice] = useState("");
  const [notes, setNotes] = useState("");

  function addCategory() {
    if (newCategoryName.length == 0) {
      createAlert("error", "Error", "Please enter category name");
      return;
    }
    const body = {
      institution_id: state.auth.user.institution_id,
      user_id: state.auth.user.user_id,
      category: newCategoryName,
    };

    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    setIsSubmitting(true);

    axios
      .post(API_URL + "/add_inventory_category", body, config)
      .then(() => {
        setIsSubmitting(false);
        setMinimum("");
        setStock("");
        setOpen4(false);
        getInventory();
      })
      .catch((err) => {
        setIsSubmitting(false);
        createAlert("error", "Error", "Failed to update stock");
      });
  }

  const handleSelect = (value) => {
    setSelect(value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  function updateStock(update) {
    if (stock.length == 0) {
      createAlert("error", "Error", "Please enter update stock value");
      return;
    }
    const body = {
      institution_id: state.auth.user.institution_id,
      user_id: state.auth.user.user_id,
      inv_id: product.inv_id,
      stock: stock,
      update: update,
      invoice: invoice,
      notes: notes,
      date: moment().format("DD-MM-YYYY"),
    };

    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    setIsSubmitting(true);

    axios
      .post(API_URL + "/update_stock", body, config)
      .then(() => {
        setIsSubmitting(false);
        setMinimum("");
        setStock("");
        setOpen4(false);
        getInventory();
      })
      .catch((err) => {
        setIsSubmitting(false);
        createAlert("error", "Error", "Failed to update stock");
      });
  }

  function onFileUpload() {
    if (selectedFile.size > 25 * 1024 * 1024) {
      createAlert("error", "Error", "File size exceeds 25MB");
      return;
    }
    if (!selectedFile.type.match("image.*")) {
      createAlert("error", "Error", "Please select an image file");
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);
    formData.append("user_id", state.auth.user.user_id);
    formData.append("institution_id", state.auth.user.institution_id);
    formData.append("category", select);
    formData.append("name", inventoryName);
    formData.append("description", inventoryDescription);
    formData.append("quantity", quantity);
    formData.append("rate", rate);
    formData.append(
      "expiry",
      isPerishable ? moment(selectedDate).format("DD-MM-YYYY") : ""
    );
    formData.append("is_perishable", isPerishable);
    formData.append("total_price", quantity * rate);

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios.post(API_URL + "/create_inventory", formData, config).then(() => {
      setIsSubmitting(false);
      setInventoryName("");
      setInventoryDescription("");
      setQuantity("");
      setRate("");
      setSelectedDate(new Date());
      setIsPerishable(false);
      setOpen2(false);
      setOpen(false);
      getInventory();
      setToggleDrawer(false);
    });

    document.getElementById("contained-button-file").value = "";
  }

  function createInventory() {
    const formData = new FormData();

    formData.append("user_id", state.auth.user.user_id);
    formData.append("institution_id", state.auth.user.institution_id);
    formData.append("category", select);
    formData.append("name", inventoryName);
    formData.append("description", inventoryDescription);
    formData.append("quantity", quantity);
    formData.append("rate", rate);
    formData.append(
      "expiry",
      isPerishable ? moment(selectedDate).format("DD-MM-YYYY") : ""
    );
    formData.append("is_perishable", isPerishable);
    formData.append("total_price", quantity * rate);

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    axios.post(API_URL + "/create_inventory", formData, config).then(() => {
      setIsSubmitting(false);
      setInventoryName("");
      setInventoryDescription("");
      setQuantity("");
      setRate("");
      setSelectedDate(new Date());
      setIsPerishable(false);
      setOpen2(false);
      setOpen(false);
      setToggleDrawer(false);
      getInventory();
    });

    document.getElementById("contained-button-file").value = "";
  }

  function deleteInventory() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body["inv_id"] = product["inv_id"];
    body = JSON.stringify(body);
    axios.post(API_URL + "/delete_inventory", body, config).then((res) => {
      setOpen3(false);
      getInventory();
    });
  }

  function getCategories() {
    return categories.map((category, index) => {
      return <MenuItem value={category}>{category}</MenuItem>;
    });
  }

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
  }

  function onFileClick(event) {
    document.getElementById("contained-button-file").value = "";
  }

  const [selectedFile, setSelectedFile] = useState("");
  useEffect(() => {
    if (selectedFile) {
      onFileUpload();
    }
  }, [selectedFile]);

  function handleSearch(text) {
    setSearch(text);
    if (text.length == 0) {
      setInventoryList(ogInventory);
      setSearch("");
      setRandom(makeid(5));
    } else {
      var tempStudents = [];

      for (var i = 0; i < ogInventory.length; i++) {
        if (
          ogInventory[i]["name"].toLowerCase().includes(text.toLowerCase()) ||
          ogInventory[i]["category"].toLowerCase().includes(text.toLowerCase())
        ) {
          tempStudents.push(ogInventory[i]);
        }
      }
      setCurrentPage(1);
      setInventoryList(tempStudents);
      setRandom(makeid(5));
    }
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function handleCurrentPage(val) {
    var tempStudents = Array.from(ogInventory);
    setSearch("");
    setCurrentPage(val);
    setInventoryList(tempStudents.splice((val - 1) * 25, 25));
  }

  function getInventory() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_inventory", body, config)
      .then((res) => {
        setProduct(res.data["inventory"][0]);
        setImgError(false);
        setOGInventory(res.data["inventory"]);
        setInventoryList(res.data["inventory"]);
        setRandom(makeid(4));
        setCategories(res.data["categories"]);
        setSelect(res.data["categories"][res.data["categories"].length - 1]);
        setNewCategory(false);
        setIsLoading(false);
      })
      .catch((e) => {});
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getInventory();
    }
  }, []);

  function getContent() {
    return (
      <div>
        {inventoryList.length == 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <SearchOffIcon
              style={{
                fontSize: "200px",
                marginBottom: "20px",
                color: themeStyle.primaryColor,
              }}
            />
            <Typography variant="h6" style={{ color: themeStyle.primaryColor }}>
              No inventory found in records
            </Typography>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                padding: "25px",
              }}
            >
              <Grid container spacing={3} justifyContent={"flex-end"}>
                <Grid item md={5}>
                  <div
                    style={{
                      backgroundColor: themeStyle.primaryCardColor,
                      borderRadius: "15px",
                      padding: "15px",
                      height: "100%",
                    }}
                  >
                    {imgError ? (
                      <div
                        style={{
                          maxWidth: "100%",
                          borderRadius: "15px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{ height: "200px" }}
                          src={require("../../img/inventory.png")}
                        />
                      </div>
                    ) : (
                      <img
                        style={{ maxWidth: "100%", borderRadius: "15px" }}
                        src={API_URL + "/media/" + product.inv_id + ".jpg"}
                        onError={() => {
                          setImgError(true);
                        }}
                      />
                    )}
                    <div
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "25px",
                        fontWeight: "bold",
                      }}
                    >
                      {product.name}
                    </div>
                    <div
                      style={{
                        color: "black",
                        fontSize: "20px",
                      }}
                    >
                      {product.description}
                    </div>
                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      Inventory Information
                    </span>
                    <hr />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Inventory Id:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.inv_id ? (
                          product.inv_id
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Category:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.category ? (
                          product.category
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Quantity:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.quantity ? (
                          product.quantity
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Rate:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.rate ? (
                          product.rate + " per unit"
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Total Price:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.total_price ? (
                          product.total_price
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Perishable</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {!product.is_perishable ? (
                          "NO"
                        ) : (
                          <span style={{ color: "#ff3333" }}>YES</span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Expiry Date</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.expiry ? product.expiry : "NON PERISHABLE"}
                      </span>
                    </div>
                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      Activity
                    </span>
                    <Grid
                      container
                      spacing={2}
                      style={{
                        justifyContent: "flex-start",
                        textAlign: "left",
                        marginTop: "15px",
                        marginLeft: "0px",
                        paddingBottom: "15px",
                        color: themeStyle.primaryColorLight,
                        borderBottom: "1px solid" + themeStyle.primaryColor,
                        backgroundColor: themeStyle.secondaryColor,
                        width: "100%",
                        borderTopRightRadius: "15px",
                        borderTopLeftRadius: "15px",
                      }}
                    >
                      <Grid item md={1}>
                        Sr
                      </Grid>
                      <Grid item md={2}>
                        Date
                      </Grid>
                      <Grid item md={2}>
                        Type
                      </Grid>
                      <Grid item md={2}>
                        Value
                      </Grid>
                      <Grid item md={2}>
                        Invoice
                      </Grid>
                      <Grid item md={3}>
                        Notes
                      </Grid>
                    </Grid>

                    <div
                      style={{
                        color: themeStyle.primaryColor,
                        marginLeft: "15px",
                      }}
                    >
                      {product.activity ? (
                        JSON.parse(product.activity).map((activity, index) => {
                          return (
                            <Grid container spacing={2}>
                              <Grid item md={1}>
                                {index + 1}
                              </Grid>
                              <Grid item md={2}>
                                {activity.date}
                              </Grid>
                              <Grid item md={2}>
                                {" "}
                                <div
                                  style={{
                                    color:
                                      activity.type == "ADD" ? "green" : "red",
                                  }}
                                >
                                  {activity.type}
                                </div>
                              </Grid>
                              <Grid item md={2}>
                                {activity.value}
                              </Grid>
                              <Grid item md={2}>
                                {activity.invoice}
                              </Grid>
                              <Grid item md={3}>
                                {activity.notes}
                              </Grid>
                            </Grid>
                          );
                        })
                      ) : (
                        <span style={{ color: "#ff3333" }}>NOT AVAILABLE</span>
                      )}
                    </div>
                    <hr />
                    <Grid container spacing={2}>
                      <Grid item md={3}></Grid>
                      <Grid item md={3}></Grid>
                      <Grid item md={3}>
                        CURRENT
                      </Grid>
                      <Grid item md={3}>
                        {" "}
                        {product.stock ? (
                          product.stock
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                  <br></br>
                  <div
                    style={{
                      marginTop: "-50px",
                      height: "50px",
                      width: "100%",
                      padding: "5px 10px",
                      borderRadius: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "none",
                      backgroundColor: themeStyle.primaryColor,
                      cursor: "pointer",
                    }}
                    onClick={() => setOpen4(true)}
                    aria-label="add"
                  >
                    <PublishIcon
                      style={{
                        color: "white",
                        marginRight: "5px",
                        fontSize: "30px",
                      }}
                    />
                    <div
                      style={{
                        color: "white",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      Update Stock
                    </div>
                  </div>
                </Grid>
                <Grid item md={7}>
                  <div
                    style={{
                      border: "3px solid " + themeStyle.primaryCardColor,
                      borderRadius: "15px",
                      padding: "15px",
                    }}
                  >
                    <Grid
                      container
                      spacing={2}
                      style={{
                        justifyContent: "flex-start",
                        textAlign: "left",
                        paddingBottom: "15px",
                        color: themeStyle.primaryColor,
                        borderBottom: "1px solid" + themeStyle.primaryColor,
                        backgroundColor: themeStyle.primaryCardColor,
                        width: "103.2%",
                        borderTopRightRadius: "15px",
                        borderTopLeftRadius: "15px",
                      }}
                    >
                      <Grid item md={1}>
                        Sr
                      </Grid>
                      <Grid item md={3}>
                        Inventory Name
                      </Grid>
                      <Grid item md={2}>
                        Category
                      </Grid>
                      <Grid item md={2} style={{ textAlign: "center" }}>
                        Quantity
                      </Grid>
                      <Grid item md={2} style={{ textAlign: "center" }}>
                        Expiry
                      </Grid>
                      <Grid item md={1}>
                        Edit
                      </Grid>
                      <Grid item md={1} style={{ textAlign: "center" }}>
                        Delete
                      </Grid>
                    </Grid>
                    {inventoryList.map((product, index) => (
                      <Grid
                        onClick={() => {
                          setProduct(product);
                          setImgError(false);
                        }}
                        container
                        spacing={2}
                        style={{
                          color: "black",
                          padding: "15px",
                        }}
                      >
                        <Grid item md={1}>
                          {index + 1}
                        </Grid>
                        <Grid
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setProduct(product);
                            setImgError(false);
                          }}
                          item
                          md={3}
                        >
                          {product["name"]}
                        </Grid>
                        <Grid
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setProduct(product);
                            setImgError(false);
                          }}
                          item
                          md={2}
                        >
                          {product["category"]}
                        </Grid>
                        <Grid item md={2} style={{ textAlign: "center" }}>
                          {product["quantity"]}
                        </Grid>
                        <Grid item md={2} style={{ textAlign: "center" }}>
                          {product["expiry"]}
                        </Grid>
                        <Grid item md={1} style={{ textAlign: "center" }}>
                          <EditIcon
                            onClick={() => {
                              setProduct(product);
                              setImgError(false);
                              setInventoryName(product["name"]);
                              setInventoryDescription(product["description"]);
                              setSelectedDate(
                                moment(product["expiry"], "DD-MM-YYYY").toDate()
                              );
                              setSelect(product["category"]);
                              setQuantity(product["quantity"]);
                              setRate(product["rate"]);
                              setIsPerishable(product["is_perishable"]);
                              setToggleDrawer(true);
                            }}
                            style={{
                              color: themeStyle.primaryColor,
                              cursor: "pointer",
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          md={1}
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <DeleteIcon
                            onClick={() => {
                              setProduct(product);
                              setOpen3(true);
                            }}
                            style={{
                              color: "#ff3333",
                              cursor: "pointer",
                              textAlign: "right",
                            }}
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </div>
                  {inventoryList.length > 15 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "-15px",
                        marginTop: "-15px",
                      }}
                    >
                      {Array.from(
                        Array(Math.ceil(ogInventory.length / 25)).keys()
                      ).map((temp, index) => (
                        <div
                          style={{
                            cursor: "pointer",
                            margin: "3px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "25px",
                            height: "25px",
                            borderRadius: "30px",
                            color: "white",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          onClick={() => {
                            handleCurrentPage(index + 1);
                          }}
                        >
                          {index + 1}
                        </div>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_inventory) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5}>
                    <Grid item md={3}>
                      {/* <Select
                      value={classs}
                      onChange={(e) => handleClassChange(e)}
                      style={{
                        height: "40px",
                        marginTop: "2px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getClassList()}
                    </Select> */}
                    </Grid>
                    <Grid item md={3}>
                      {/* <Select
                      value={division}
                      onChange={(e) => handleDivisionChange(e)}
                      style={{
                        height: "40px",
                        marginTop: "2px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getDivisionList()}
                    </Select> */}
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Search Inventory"
                        variant="outlined"
                        value={search}
                        size="small"
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                }
              />
              <Drawer
                anchor={"right"}
                open={toggleDrawer}
                onClose={() => setToggleDrawer(false)}
              >
                {isSubmitting ? (
                  <div
                    style={{
                      marginTop: "60px",
                      padding: "20px",
                      width: "400px",
                      backgroundColor: "white",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress />
                    <h3>Uploading in progress...</h3>
                  </div>
                ) : (
                  <div
                    style={{
                      padding: "15px",
                      marginTop: "23px",
                      width: "25vw",
                    }}
                  >
                    <div
                      style={{
                        marginTop: "25px",
                        color: themeStyle.primaryColor,

                        fontSize: "14px",
                      }}
                    >
                      Select Category
                    </div>
                    <Select
                      value={select}
                      onChange={(e) => handleSelect(e.target.value)}
                      style={{ marginTop: "2px", height: "40px" }}
                      variant={"outlined"}
                      fullWidth
                    >
                      {getCategories()}
                    </Select>
                    {!newCategory && (
                      <div
                        style={{
                          marginTop: "15px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            height: "25px",
                            width: "150px",
                            padding: "5px 10px",
                            borderRadius: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "none",
                            backgroundColor: themeStyle.primaryColor,
                            cursor: "pointer",
                          }}
                          onClick={() => setNewCategory(true)}
                          aria-label="add"
                        >
                          <AddIcon
                            style={{
                              color: "white",
                              marginRight: "5px",
                              fontSize: "20px",
                            }}
                          />
                          <div
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "bold",
                            }}
                          >
                            New Category
                          </div>
                        </div>
                      </div>
                    )}
                    {newCategory && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "15px",
                          marginTop: "15px",
                        }}
                      >
                        <TextField
                          style={{ marginTop: "2px" }}
                          value={newCategoryName}
                          fullWidth
                          size="small"
                          onChange={(e) => setNewCategoryName(e.target.value)}
                          placeholder={"Category Name"}
                          variant="outlined"
                        />
                        <div
                          style={{
                            height: "40px",
                            width: "40px",
                            padding: "5px 10px",
                            marginLeft: "5px",
                            borderRadius: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "none",
                            backgroundColor: themeStyle.primaryColor,
                            cursor: "pointer",
                          }}
                          onClick={() => addCategory()}
                          aria-label="add"
                        >
                          <AddIcon
                            style={{
                              color: "white",
                              fontSize: "30px",
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <span
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "14px",
                      }}
                    >
                      Name
                    </span>
                    <TextField
                      style={{ marginTop: "2px" }}
                      value={inventoryName}
                      fullWidth
                      size="small"
                      onChange={(e) => setInventoryName(e.target.value)}
                      placeholder={"Item Name"}
                      variant="outlined"
                    />
                    <br></br>
                    <div style={{ marginTop: "5px" }}>
                      <span
                        style={{
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Rate
                      </span>
                      <TextField
                        style={{ marginTop: "2px" }}
                        fullWidth
                        value={rate.toString()}
                        onChange={(e) => setRate(parseFloat(e.target.value))}
                        size="small"
                        placeholder="Rate"
                        variant="outlined"
                        type="number"
                      />
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      <span
                        style={{
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Quantity
                      </span>
                      <TextField
                        style={{ marginTop: "2px" }}
                        fullWidth
                        value={quantity.toString()}
                        onChange={(e) =>
                          setQuantity(parseFloat(e.target.value))
                        }
                        size="small"
                        placeholder="Quantity"
                        variant="outlined"
                        type="number"
                      />
                      <div
                        style={{
                          marginTop: "15px",
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Item Description
                      </div>
                      <TextField
                        style={{ marginTop: "2px" }}
                        multiline
                        value={inventoryDescription}
                        onChange={(e) =>
                          setInventoryDescription(e.target.value)
                        }
                        rows={4}
                        fullWidth
                        variant="outlined"
                        placeholder={"Description"}
                      />
                      <br></br>
                      <div
                        style={{
                          marginTop: "15px",
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Invoice Number
                      </div>
                      <TextField
                        style={{ marginTop: "2px" }}
                        value={invoice}
                        onChange={(e) => setInvoice(e.target.value)}
                        fullWidth
                        variant="outlined"
                        placeholder={"Description"}
                      />
                      <br></br>
                      <div
                        style={{
                          marginTop: "15px",
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Remarks / Notes
                      </div>
                      <TextField
                        style={{ marginTop: "2px" }}
                        multiline
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows={4}
                        fullWidth
                        variant="outlined"
                        placeholder={"Description"}
                      />
                      <br></br>
                    </div>
                    <h1>Total &#8377;{quantity * rate}</h1>
                    <Checkbox
                      labelStyle={{ color: themeStyle.primaryColor }}
                      iconStyle={{ fill: "white" }}
                      inputStyle={{ color: themeStyle.primaryColor }}
                      style={{
                        marginBottom: "2px",
                        color: themeStyle.primaryColor,
                      }}
                      checked={isPerishable}
                      onChange={(e) => {
                        setIsPerishable(e.target.checked);
                      }}
                      value={1}
                      color={"primary"}
                    />
                    <span
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "14px",
                      }}
                    >
                      Is Item Perishable?
                    </span>
                    <br></br>
                    {isPerishable ? (
                      <div>
                        <div
                          style={{
                            marginTop: "5px",
                            color: themeStyle.primaryColor,

                            fontSize: "14px",
                          }}
                        >
                          Expiry Date
                        </div>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="dd-MM-yyyy"
                            value={selectedDate}
                            sx={{
                              height: "40px",
                              width: "100%",
                              marginTop: "5px",
                              marginBottom: "20px",
                            }}
                            onChange={handleDateChange}
                            fullWidth
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "100%",
                                  marginTop: "2px",
                                  marginBottom: "5px",
                                  height: "40px",
                                }}
                                size="small"
                                fullWidth
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    ) : (
                      ""
                    )}
                    <br></br>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        height: "35px",
                      }}
                    >
                      <Button
                        fullWidth
                        onClick={() => {
                          setOpen2(true);
                        }}
                        variant="contained"
                        style={{
                          backgroundColor: themeStyle.primaryColor,
                          boxShadow: "none",
                          height: "40px",
                        }}
                      >
                        <h4>Save Item</h4>
                      </Button>
                    </Box>
                  </div>
                )}
              </Drawer>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open3}
                onClose={() => setOpen3(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open3}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                      borderRadius: "15px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>Delete this item?</h3>
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen3(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>
                      <br />
                      <span>
                        This action cannot be reversed. It will be deleted
                        forever.
                      </span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => deleteInventory()}
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          Yes
                        </Button>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => setOpen3(false)}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open4}
                onClose={() => setOpen4(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open4}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                      borderRadius: "15px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>Update Stock</h3>
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen4(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>
                      <br />
                      <span>
                        Enter stock and choose Add or Remove from stock
                      </span>
                      <br></br>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Stock update"
                        variant="outlined"
                        value={stock}
                        size="small"
                        type="number"
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => setStock(e.target.value)}
                      />
                      <br></br>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Invoice Number"
                        variant="outlined"
                        value={invoice}
                        size="small"
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => setInvoice(e.target.value)}
                      />
                      <br></br>
                      <br></br>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Notes / Remarks"
                        variant="outlined"
                        value={notes}
                        size="small"
                        multiline
                        rows={4}
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => setNotes(e.target.value)}
                      />
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => updateStock("ADD")}
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          ADD TO STOCK
                        </Button>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: "#ff3333",
                          }}
                          variant="contained"
                          onClick={() => updateStock("REMOVE")}
                        >
                          REMOVE FROM STOCK
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open2}
                onClose={() => setOpen2(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open2}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                      borderRadius: "15px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>Upload Image?</h3>
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen2(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>
                      <br />
                      <span>
                        Would you like to upload an image of this Inventory
                      </span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <label htmlFor="contained-button-file">
                          <input
                            style={{ display: "none" }}
                            id="contained-button-file"
                            type="file"
                            onChange={(e) => {
                              if (
                                select == "" ||
                                inventoryName == "" ||
                                inventoryDescription == "" ||
                                quantity == "" ||
                                rate == ""
                              ) {
                                createAlert(
                                  "error",
                                  "Error",
                                  "Please fill in all fields"
                                );
                                setIsSubmitting(false);
                                return;
                              } else {
                                onFileChange(e);
                              }
                            }}
                          />
                          <Button
                            style={{
                              height: "30px",
                              backgroundColor: themeStyle.primaryColor,
                            }}
                            variant="contained"
                            component="span"
                          >
                            Yes
                          </Button>
                        </label>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => {
                            createInventory();
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <div
                style={{
                  height: "50px",
                  width: "175px",
                  padding: "5px 10px",
                  borderRadius: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "none",
                  backgroundColor: themeStyle.primaryColor,
                  position: "fixed",
                  bottom: 30,
                  right: 30,
                  cursor: "pointer",
                }}
                onClick={() => setToggleDrawer(true)}
                aria-label="add"
              >
                <PublishIcon
                  style={{
                    color: "white",
                    marginRight: "5px",
                    fontSize: "30px",
                  }}
                />
                <div
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  New Item
                </div>
              </div>
              <div
                style={{
                  margin: "45px 0px 20px 70px",
                  backgroundColor: "white",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Inventory;
